import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    height: theme.spacing(2.75),
    alignItems: 'center',
  },
  visited: {
    backgroundColor: theme.palette.purple.main,
  },
  unvisited: {
    backgroundColor: theme.palette.gray.main,
    opacity: 0.5,
  },
  circle: {
    color: theme.palette.white.main,
    width: theme.spacing(2.75),
    height: theme.spacing(2.75),
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    ...theme.typography.subtitle2,
  },
  whiteCircle: {
    backgroundColor: theme.palette.white.main,
    width: theme.spacing(1.25),
    height: theme.spacing(1.25),
    borderRadius: '50%',
  },
  tick: {
    width: theme.spacing(1.125),
    height: theme.spacing(0.875),
  },
}));
